// extracted by mini-css-extract-plugin
export default {"noticePolicyForm":"noticePolicyForm---Fv8mP"};